import CustomCircularProgressBar from "@/circular/circularprogressbar";

CustomCircularProgressBar.install = Vue =>Vue.component(CustomCircularProgressBar.name,CustomCircularProgressBar);//注册组件
//
// const install = function (Vue, opts = {}) {
//     Vue.component(circularProgressbar.name,circularProgressbar)
// }
// if (typeof window !== 'undefined' && window.Vue){
//     install(window.Vue);
// }

// const Components = {
//     circularProgressbar
// }
// Object.keys(Components).forEach(name=>{
//     Vue.component(name,Components[name])
// })
export default CustomCircularProgressBar;